import { Skeleton } from "@mui/material";

export default function LoadingSkeleton() {
  return (
    <div className="d-flex flex-column">
      {Array(4)
        .fill(0)
        .map((_, index) => (
          <Skeleton
            key={index}
            variant="rectangular"
            className="my-2 mx-1"
            width="100%"
            height={28}
          />
        ))}
    </div>
  );
}
